import * as oidc from 'oidc-client-ts';
import { useCallback, useEffect, useRef } from 'react';
import { oidcStores } from '~/lib/oidc-storage';

export default function Component() {
  // An authorization code can only be exchanged once. StrictMode runs this effect twice in dev, and
  // the second exchange fails with invalid_grant, so only the first run is allowed through.
  const started = useRef(false);

  const load = useCallback(() => {
    window.location.hash = decodeURIComponent(window.location.hash);

    const mgr = new oidc.UserManager({
      authority: `https://parcel2go.test.p2g.ninja/auth`,
      client_id: 'smartsend.cs',
      loadUserInfo: true,
      redirect_uri: '/myaccount/',
      ...oidcStores()
    });

    mgr.signinRedirectCallback().then(
      (user) => {
        window.history.replaceState({}, window.document.title, window.location.origin);

        if (user.state) {
          console.log('AUTH CALLBACK', user.state);
          window.location.href = user.state as string;
        } else {
          console.log('AUTH CALLBACK');
          window.location.href = '/';
        }
      },
      (error) => {
        console.error(error);
        window.location.href = '/';
      }
    );
  }, []);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    load();
  }, [load]);

  return <>Loading...</>;
}

Component.displayName = 'SignIn';
